<h1 *ngIf="useCustomTitle" [innerHTML]="customTitle"></h1>
<h1 *ngIf="!useCustomTitle">{{ 'menu.' + currentRoute | translate }}</h1>
